var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCloseMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(36.059143968871595 36.05914396887157) scale(2.03 2.03)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10.67,
    y: 37.03,
    rx: 0,
    ry: 0,
    width: 111.33,
    height: 15.95,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(236,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(0.7071 -0.7071 0.7071 0.7071 -18.6396 44.9973) "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.03,
    y: -10.67,
    rx: 0,
    ry: 0,
    width: 15.95,
    height: 111.33,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(236,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(0.7071 -0.7071 0.7071 0.7071 -18.6396 44.9996) "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCloseMark);
export default __webpack_public_path__ + "static/media/red-close-mark.a2854f91b340ec7c5ea7bb0f3c1552f4.svg";
export { ForwardRef as ReactComponent };